import React from 'react'

const Education = () => {
    return (
        <div className="col col-d-6 col-t-6 col-m-12 border-line-v">
            <div className="resume-title border-line-h">
                <div className="icon"><i className="fa fa-university"></i></div>
                <div className="name">Education</div>
            </div>
            <div className="resume-items">
                <div className="resume-item border-line-h">
                    <div className="date">2010 - 2013</div>
                    <div className="name">Bachelor of Engineering</div>
                    <div className="company">S.I.E.R, Savitribai Phule Pune University</div>
                    <p>
                        Bachelor's Degree in Computer Science
                    </p>
                </div>
                <div className="resume-item border-line-h">
                    <div className="date">2007 - 2010</div>
                    <div className="name">High School Diploma</div>
                    <div className="company">MAEER's SSPP, Maharastra State Board of Technical Education</div>
                    <p>
                        High School Diploma in Information Technology
                    </p>
                </div>
                <div className="resume-item">
                    <div className="date">1996 - 2007</div>
                    <div className="name">High Secondary Education</div>
                    <div className="company">Bhartiya Vidya Bhavan, Maharastra State Board</div>
                    <p>
                        Higher Secondary Education
                    </p>
                </div>
            </div>
        </div>
    );
}

export default Education;